// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class PetsAPI extends MainAPI {
	/**
	 * @param {*} petId
	 */
	async getPetById(petId) {
		return API.get(`${ENDPOINTS.GET_PET_BY_ID}/${petId}`);
	}

	/**
	* @return Pet Weight
	*/
	async getPetWeight(petDetailsInfo) {
		return API.get(ENDPOINTS.GET_WEIGHT, petDetailsInfo);
	}

	/**
	 * @param {*} petId
	 * @param {*} petDetails
	 * */
	async putPetById(petId, petDetails) {
		let newFormData = new FormData();

		newFormData.append('formData', JSON.stringify(petDetails.formData));

		if (petDetails.formData.isImageChanged) {
			newFormData.append('profileImage', petDetails.profileImage);
		}

		return API.put(`${ENDPOINTS.PUT_PET}/${petId}`, newFormData);
	}

	/**
	 * @param {*} petId
	 * @param {*} secondaryImage
	 * */
	 async putUpdateSecondaryImage(petId, secondaryImage) {
		let newFormData = new FormData();
		
		newFormData.append('secondaryImage', secondaryImage);
		
		return API.put(`${ENDPOINTS.PUT_PET}/${petId}/secondary-image`, newFormData);
	}

	/**
	* @return NO CONTENT
	*/
	async putUpdateMicrochip(microchipCode, petId) {
		return API.put(`${ENDPOINTS.PUT_PET}/${petId}/microchip`, microchipCode);
	}

	/**
	 * @params {*} petId
	 * */
	async deletePetById(petId) {
		return API.delete(`${ENDPOINTS.DELETE_PET}/${petId}`);
	}

	/** 
	 * @param {*} petDetails
	 */
	async postPet(petDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(petDetails.formDetails)
		);
		newFormData.append(
			'profileImage',
			petDetails.petImg
		);
		return API.post(ENDPOINTS.POST_PET, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	/**
	* @params {*} petId
	* */
	async deleteMicrochip(petId) {
		return API.delete(`${ENDPOINTS.DELETE_PET}/${petId}/microchip`);
	}

	/**
	* @params {*} petId
	* @params {Object} petWeightDetails
	* */
	async addPetWeight(petId, petWeightDetails) {
		return API.post(`${ENDPOINTS.POST_PET}/${petId}/weight`, petWeightDetails);
	}

	/**
	* @params {*} petId
	* @params {Object} petWeightDetails
	* */
	async editPetWeight(petId, petWeightDetails) {
		return API.put(`${ENDPOINTS.PUT_PET}/${petId}/weight`, petWeightDetails);
	}

	/**
	* @params {Object} purchaseDetails
	* */
	async addPetPurchase(purchaseDetails) {
		return API.post(`${ENDPOINTS.POST_PET_ORDER}`, purchaseDetails);
	}

	/**
	* @params {Object} purchaseDetails
	* */
	async getPetPurchase(purchaseDetails) {
		return API.get(`${ENDPOINTS.GET_PET_ORDERS}?${queryString.stringify(purchaseDetails)}`);
	}

	/**
	* @params {*} petOrderId
	* */
	async deletePetOrder(petOrderId) {
		return API.delete(`${ENDPOINTS.DELETE_PET_ORDER}/${petOrderId}`);
	}
}

export default new PetsAPI();
